'use client';

import { configureSync, getConsoleSink } from '@logtape/logtape';

import { getDatadogClientSink } from './logger/sinks/datadog.client';

configureSync({
  sinks: {
    console: getConsoleSink(),
    datadog: getDatadogClientSink(),
    meta: getConsoleSink({
      formatter: (record) =>
        `[META] ${record.level} ${record.message}`,
    }),
  },
  loggers: [
    {
      category: 'app',
      lowestLevel: 'info',
      sinks: ['console', 'datadog'],
    },
    {
      category: ['logtape', 'meta'],
      lowestLevel: 'warning',
      sinks: ['meta'],
    },
  ],
});
